export default "__VITE_ASSET__DHt9n2$x__"